import AnalyticsEventsCollectorInterface from "@modules/analytics_events_collector/AnalyticsEventsCollector/AnalyticsEventsCollectorInterface";

import SdkAnalyticsEventsFactory from "../analytics/SdkAnalyticsEventsFactory";
import { SDK_MODULES } from "../constants";
import { ensureMethodCalledEventTriggeredOnceDaily } from "../helpers";
import Sdk from "../Sdk";
import { COMMON_SDK_EVENTS } from "./constants";

class CommonSdkEvents {
    constructor(
        private readonly sdk: Sdk,
        private readonly eventsCollector: AnalyticsEventsCollectorInterface,
        private readonly eventsFactory: SdkAnalyticsEventsFactory
    ) {}

    public readonly WIDGET_CLOSED = COMMON_SDK_EVENTS.WIDGET_CLOSED;
    public readonly WIDGET_INJECTED = COMMON_SDK_EVENTS.WIDGET_INJECTED;
    public readonly WIDGET_OPENED = COMMON_SDK_EVENTS.WIDGET_OPENED;

    /**
     * @deprecated This method has been moved to the SDK core.
     *
     * Compatibility details:
     * - Previously used as: `gw.sdk.common.events.runIfModuleReady`.
     * - Kept for backward compatibility to support existing users.
     *
     * Notes:
     * - All usages of `common.events.runIfModuleReady` were replaced with `sdk.runIfModuleReady`
     * in customizations found in the `crm_customfile` table and in ClickHouse.
     * - However, it is still used at least in the Dromenwinkel custom shop, which loads this code from Shopify assets.
     * Date: 2025-07-10
     */
    public runIfModuleReady(
        moduleName: Exclude<SDK_MODULES, SDK_MODULES.COMMON>,
        callback: () => void
    ): void {
        ensureMethodCalledEventTriggeredOnceDaily(
            "runIfModuleReady",
            "sdk.common.events",
            () => {
                this.eventsCollector.pushEvent(
                    this.eventsFactory.createMethodCalled(
                        "runIfModuleReady",
                        false,
                        "sdk.common.events"
                    )
                );
            }
        );
        console.error(
            "[Growave SDK Method Deprecated Warning]: The method 'runIfModuleReady' in 'sdk.common.events' is deprecated. Please use 'runIfModuleReady' from 'sdk.runIfModuleReady' instead. Refer to the latest SDK documentation for more details."
        );
        this.sdk.runIfModuleReady(moduleName, callback);
    }
}

export default CommonSdkEvents;
